export default "__VITE_ASSET__Bicb30hc__"